import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Axios from 'axios';


Vue.use(VueRouter);

function getBaseREGApiUrl() {
    return window.env.VUE_APP_API_REG_DEV;
}
function getBaseSLGLApiUrl() {
    return window.env.VUE_APP_API_SLGL_DEV;
}
function getBaseMMLApiUrl() {
    return window.env.VUE_APP_API_MML_DEV;
}
function getBaseSPApiUrl() {
    return window.env.VUE_APP_API_SP_DEV;
}
function getBasePPPApiUrl() {
    return window.env.VUE_APP_API_PPP_DEV;
}

const routes = [


    {
        path: '/',
        name: 'home',
        component: Home,
        props: { pageClass: 'standard' }
    },

    // ---------------------------------------------------User pages--------------------------------------------------------------
    {
        path: '/user',
        name: 'UserPage',
        component: () => import('../views/UserPage.vue')
    },
    {
        path: '/reset-pass',
        name: 'ResetPassPage',
        component: () => import('../views/ResetPassPage.vue')
    },

    {
        path: '/newsletter',
        name: 'NewsletterPage',
        component: () => import('../views/NewsletterPage.vue')
    },

    {
        path: '/promo',
        name: 'PromoForm',
        component: () => import('../views/PromoForm.vue')
    },
    // ---------------------------------------------------------News pages--------------------------------------------------------
    {
        path: '/news-cat/:id/:page',
        name: 'NewsCategoryPage',
        component: () => import('../views/NewsCategoryPage.vue')
    },
    {
        path: '/news-multimedia/:page',
        name: 'NewsMultimediaPage',
        component: () => import('../views/NewsMultimediaPage.vue')
    },
    {
        path: '/news-search',
        name: 'NewsSearchPage',
        component: () => import('../views/NewsSearchPage.vue')
    },
    // Bases pages
    // =================================================================================================================
    // slglrs base pages | Службени гласник Републике Србије
    // -----------------------------------------------------------------------------------------------------------------
    // NP
    {
        path: '/slglrsNP-overview/:numberId',
        name: 'SlglrsNP_OverviewPage',
        component: () => import('../base_pages/slglrs/SlglrsNP_OverviewPage.vue')
    },
    {
        path: '/slglrsNP-all-issues',
        name: 'SlglrsNP_AllIssuesPage',
        component: () => import('../base_pages/slglrs/SlglrsNP_AllIssuesPage.vue')
    },
    {
        path: '/slglrsNP-search',
        name: 'SlglrsNP_SearchPage',
        component: () => import('../base_pages/slglrs/SlglrsNP_SearchPage.vue')
    },
    // MUTG
    {
        path: '/slglrsMUTG-overview/:numberId',
        name: 'SlglrsMUTG_OverviewPage',
        component: () => import('../base_pages/slglrs/SlglrsMUTG_OverviewPage.vue')
    },
    {
        path: '/slglrsMUTG-all-issues',
        name: 'SlglrsMUTG_AllIssuesPage',
        component: () => import('../base_pages/slglrs/SlglrsMUTG_AllIssuesPage.vue')
    },
    {
        path: '/slglrsMUTG-search',
        name: 'SlglrsMUTG_SearchPage',
        component: () => import('../base_pages/slglrs/SlglrsMUTG_SearchPage.vue')
    },
    {
        path: '/slglrs/viewAct/:actId',
        name: 'SLGLRS_ViewActPage',
        component: () => import('../base_pages/slglrs/ViewActPage.vue'),
        alias: ['/SlGlasnikPortal/slglrs/viewAct/:actId?']
    },
    // PG2010
    {
        path: '/slglrsPG2010-overview/:numberId',
        name: 'SlglrsPG2010_OverviewPage',
        component: () => import('../base_pages/slglrs/SlglrsPG2010_OverviewPage.vue')
    },
    {
        path: '/slglrsPG2010-all-issues',
        name: 'SlglrsPG2010_AllIssuesPage',
        component: () => import('../base_pages/slglrs/SlglrsPG2010_AllIssuesPage.vue')
    },
    {
        path: '/slglrsPG2010-search',
        name: 'SlglrsPG2010_SearchPage',
        component: () => import('../base_pages/slglrs/SlglrsPG2010_SearchPage.vue')
    },
    {
        path: '/slglrs-static',
        name: 'SlglrsStaticPage',
        component: () => import('../base_pages/slglrs/SlglrsStaticPage.vue')
    },
    // {
    //     path: '/fp/izbori',
    //     name: 'FpIzbori',
    //     component: () => import( '../base_pages/fp/FpIzbori.vue')
    // },
    {
        path: '/fp/saziv-drzavnih-organa',
        name: 'FpSazivDrzavnihOrgana',
        component: () => import('../base_pages/fp/FpSazivDrzavnihOrgana.vue')
    },
    {
        path: '/fp/covid19',
        name: 'FpCovid19',
        component: () => import('../base_pages/fp/FpCovid19.vue')
    },
    {
        path: '/fp/newsletter',
        name: 'FpVerify',
        component: () => import('../base_pages/fp/FpVerify.vue')
    },
    // {
    //     path: '/slglrs/viewActPdf/:actId',
    //     name: 'SLGLRS_ViewActPagePdf',
    //     component: () => import( '../base_pages/slglrs/ViewActPagePdf.vue')
    // },

    // numberOverview
    // {
    //     path: '/slglrs/numberOverview/:code/:actId',
    //     name: 'SlglrsNP_NumberOverviewPage',
    //     component: () => import( '../base_pages/slglrs/SlglrsNP_NumberOverviewPage.vue')
    // },


    // reg base pages | Регистар и текстови важећих прописа и других аката
    // -----------------------------------------------------------------------------------------------------------------
    {
        path: '/reg-overview',
        name: 'RegOverviewPage',
        component: () => import('../base_pages/reg/RegOverviewPage.vue')
    },
    {
        path: '/reg-search',
        name: 'RegSearchPage',
        component: () => import('../base_pages/reg/RegSearchPage.vue')
    },
    {

        path: '/reg-static',
        name: 'RegBaseStaticPage',
        component: () => import('../base_pages/reg/BaseStaticPage.vue')
    },
    {
        path: '/reg-latest',
        name: 'RegLatestPage',
        component: () => import('../base_pages/reg/RegLatestPage.vue')
    },
    // {
    //     path: '/reg/viewAct/:actTitle/:actId',
    //     name: 'REG_ViewActPage',
    //     component: () => import( '../base_pages/reg/ViewActPage.vue')
    // },
    // {
    //     path: '/eli/rep/:base/:body/:type/:year/:id/:version/:color',
    //     name: 'REG_EliViewActPage',
    //     component: () => import( '../base_pages/reg/EliViewActPage.vue')
    // },
    // arhslgl base pages | Архива службених гласила
    // -----------------------------------------------------------------------------------------------------------------
    {
        path: '/arhslgl-sgarh',
        name: 'ArhslglSgarhPage',
        component: () => import('../base_pages/arhslgl/ArhslglSgarhPage.vue')
    },
    {
        path: '/arhslgl-sgarh-search',
        name: 'ArhslglSgarhSearchPage',
        component: () => import('../base_pages/arhslgl/ArhslglSgarhSearchPage.vue')
    },
    {
        path: '/arhslgl-pgarh',
        name: 'ArhslglPgarhPage',
        component: () => import('../base_pages/arhslgl/ArhslglPgarhPage.vue')
    },
    {
        path: '/arhslgl-pgarh-search',
        name: 'ArhslglPgarhSearchPage',
        component: () => import('../base_pages/arhslgl/ArhslglPgarhSearchPage.vue')
    },
    {
        path: '/arhslgl-muarh',
        name: 'ArhslglMuarhPage',
        component: () => import('../base_pages/arhslgl/ArhslglMuarhPage.vue')
    },
    {
        path: '/arhslgl-muarh-search',
        name: 'ArhslglMuarhSearchPage',
        component: () => import('../base_pages/arhslgl/ArhslglMuarhSearchPage.vue')
    },
    {
        path: '/arhslgl-slarh',
        name: 'ArhslglSlarhPage',
        component: () => import('../base_pages/arhslgl/ArhslglSlarhPage.vue')
    },
    {
        path: '/arhslgl-slarh-search',
        name: 'ArhslglSlarhSearchPage',
        component: () => import('../base_pages/arhslgl/ArhslglSlarhSearchPage.vue')
    },
    {
        path: '/arhslgl-static',
        name: 'ArhslglStaticPage',
        component: () => import('../base_pages/arhslgl/ArhslglStaticPage.vue')
    },
    // numberOverview
    {
        path: '/arhslgl/numberOverview/sgarh/:actId',
        name: 'SgarhNumberOverviewPage',
        component: () => import('../base_pages/arhslgl/SgarhNumberOverviewPage.vue')
    },
    {
        path: '/arhslgl/numberOverview/slarh/:actId',
        name: 'SlarhNumberOverviewPage',
        component: () => import('../base_pages/arhslgl/SlarhNumberOverviewPage.vue')
    },
    {
        path: '/arhslgl/numberOverview/pgarh/:actId',
        name: 'PgarhNumberOverviewPage',
        component: () => import('../base_pages/arhslgl/PgarhNumberOverviewPage.vue')
    },
    {
        path: '/arhslgl/numberOverview/muarh/:actId',
        name: 'MuarhNumberOverviewPage',
        component: () => import('../base_pages/arhslgl/MuarhNumberOverviewPage.vue')
    },
    {
        path: '/slglrsViewPdf/:actId',
        name: 'SlglrsPDFJSViewer',
        component: () => import('../base_pages/slglrs/SlglrsPDFJSViewer.vue')
    },

    // {
    //     path: '/arhslgl/viewActPdf/:actId',
    //     name: 'ARHSLGL_ViewActPagePdf',
    //     component: () => import( '../base_pages/arhslgl/ViewActPagePdf.vue')
    // },
    // {
    //     path: '/arhslgl/viewAct/:actTitle/:actId',
    //     name: 'ARHSLGL_ViewActPage',
    //     component: () => import( '../base_pages/arhslgl/ViewActPage.vue')
    // },


    // ---------------------------------------------------Guide pages--------------------------------------------------------------
    // GuidePageBasicInfo
    {
        path: '/guide/:page',
        name: 'GuidePage',
        component: () => import('../views/GuidePage.vue')
    },
    //--------------------------------------------MML Pages-------------------------------------------------------------
    {
        path: '/mml-standard-search',
        name: 'MmlStandardSearchPage',
        component: () => import('../base_pages/mml/MmlStandardSearchPage.vue')
    },
    {
        path: '/mml-latest',
        name: 'MmlLatestPage',
        component: () => import('../base_pages/mml/MmlLatestPage.vue')
    },
    {
        path: '/mml-opinion-search',
        name: 'MmlOpinionSearchPage',
        component: () => import('../base_pages/mml/MmlOpinionSearchPage.vue')
    },
    {
        path: '/mml/viewAct/:actId',
        name: 'MML_ViewActPage',
        component: () => import('../base_pages/mml/ViewActPage.vue'),
        alias: ['/SlGlasnikPortal/mml/viewAct/:actId?']
    },

    {

        path: '/unifiedSearch',
        name: 'UnifiedSearchPage',
        component: () => import('../views/UnifiedSearchPage.vue')
    },
    {
        path: '/static/:page',
        name: 'StaticPage',
        component: () => import('../views/StaticPage.vue')
    },
    // -------------------------------------------------------PP pages----------------------------------------------------------
    {
        path: '/pp-content/:extCode',
        name: 'PpContentPage',
        params: true,
        component: () => import('../base_pages/pp/PpContentPage.vue')
    },
    {
        path: '/pp-latest/:extCode',
        name: 'PpLatestPage',
        component: () => import('../base_pages/pp/PpLatestPage.vue')
    },
    {
        path: '/pp-search/:extCode',
        name: 'PpSearchPage',
        component: () => import('../base_pages/pp/PpSearchPage.vue')
    },
    {
        path: '/pp-static/:extCode',
        name: 'PpStaticPage',
        component: () => import('../base_pages/pp/PpStaticPage.vue')
    },
    {
        path: '/ppp/viewAct/:actId',
        name: 'PP_ViewActPage',
        component: () => import('../base_pages/pp/ViewActPage.vue'),
        alias: ['/SlGlasnikPortal/ppp/viewAct/:actId?']
    },
    {
        path: '/pppViewPdf/:actId',
        name: 'PppPDFJSViewer',
        component: () => import('../base_pages/pp/PppPDFJSViewer.vue')
    },
    // ------------------------------------------------------SUPA pages-----------------------------------------------------------
    {
        path: '/supa-latest',
        name: 'SupaLatestPage',
        component: () => import('../base_pages/supa/SupaLatestPage.vue')
    },
    {
        path: '/supa-standardSearch',
        name: 'SupaStandardSearchPage',
        component: () => import('../base_pages/supa/SupaStandardSearchPage.vue')
    },
    {
        path: '/supa-advancedSearch-ccSearch',
        name: 'SupaAdvancedSearchCcSearchPage',
        component: () => import('../base_pages/supa/SupaAdvancedSearchCcSearchPage.vue')
    },
    {
        path: '/supa-advancedSearch-ocSearch',
        name: 'SupaAdvancedSearchOcSearchPage',
        component: () => import('../base_pages/supa/SupaAdvancedSearchOcSearchPage.vue')
    },
    {
        path: '/supa-advancedSearch-fcSearch',
        name: 'SupaAdvancedSearchFcSearchPage',
        component: () => import('../base_pages/supa/SupaAdvancedSearchFcSearchPage.vue')
    },
    {
        path: '/supa-advancedSearch-biltenSearch',
        name: 'SupaAdvancedSearchBiltenSearchPage',
        component: () => import('../base_pages/supa/SupaAdvancedSearchBiltenSearchPage.vue')
    },
    {
        path: '/supa-registries',
        name: 'SupaRegistriesPage',
        component: () => import('../base_pages/supa/SupaRegistriesPage.vue')
    },
    {
        path: '/supa-static',
        name: 'SupaStaticPage',
        component: () => import('../base_pages/supa/SupaStaticPage.vue')
    },
    {
        path: '/supa/viewAct/:actId',
        name: 'SUPA_ViewActPage',
        component: () => import('../base_pages/supa/ViewActPage.vue'),
        alias: ['/SlGlasnikPortal/supa/viewAct/:actId?']
    },
    {
        path: '/mml-qa-search',
        name: 'MmlQaSearchPage',
        component: () => import('../base_pages/mml/MmlQaSearchPage.vue')
    },
    {
        path: '/mml-model-search',
        name: 'MmlModelSearchPage',
        component: () => import('../base_pages/mml/MmlModelSearchPage.vue')
    },
    {
        path: '/mml-literature-search',
        name: 'MmlLiteratureSearchPage',
        component: () => import('../base_pages/mml/MmlLiteratureSearchPage.vue')
    },
    {
        path: '/mml-static',
        name: 'MmlStaticPage',
        component: () => import('../base_pages/mml/MmlStaticPage.vue')
    },
    {
        path: '/fp/eurlex',
        name: 'FpEurlex',
        component: () => import('../base_pages/fp/FpEurlex.vue')
    },
    {
        path: '/fp/pretraga-nevazecih-isprava',
        name: 'FpSearchNadjiMo',
        component: () => import('../base_pages/fp/FpSearchNadjiMo.vue')
    },
    {
        path: '/fp/statistics',
        name: 'FpStatistics',
        component: () => import('../base_pages/fp/FpStatistics.vue')
    },
    {
        path: '/fp/presentation-query',
        name: 'FpPresentationQuery',
        component: () => import('../base_pages/fp/FpPresentationQuery.vue')
    },
    {
        path: '/fp/:page',
        name: 'FpUsefulLinks',
        component: () => import('../base_pages/fp/FpUsefulLinks.vue')
    },
    {
        path: '/calc/zatezne-kamate',
        name: 'InterestCalculator',
        component: () => import('../base_pages/calc/InterestCalculator.vue')
    },
    {
        path: '/calc/sudske-takse',
        name: 'CourtFeesCalculator',
        component: () => import('../base_pages/calc/CourtFeesCalculator.vue')
    },
    {
        path: '/calc/pomoc',
        name: 'CalculatorHelp',
        component: () => import('../base_pages/calc/CalculatorHelp.vue')
    },

    {
        path: '/viewPdf/:actId',
        name: 'RegPDFJSViewer',
        component: () => import('../base_pages/reg/RegPDFJSViewer.vue')
    },
    {
        path: '/viewAct/:actId?',
        name: 'ViewActPage',
        component: () => import('../base_pages/reg/ViewActPage.vue'),
        alias: ['/SlGlasnikPortal/reg/viewAct/:actId?']
    },
    {
        path: '/evropska-oznaka-zakonodavstva',
        name: 'EliOverview',
        component: () => import('../base_pages/eli/EliOverview.vue')
    },

    {
        path: '/calendar',
        name: 'CalendarPage',
        component: () => import('../views/CalendarPage.vue')
    },
    //------------------------------------------Eli------------------------------------------
    {
        path: '/eli/:level?/:issueType?/:authority/:docType/:gazetteYear(\\d+)?/:gazetteNumber(\\d+)?/:number(\\d+)?/:formatOrServiceOrTimestamp1?/:formatOrServiceOrTimestamp2?/:formatOrServiceOrTimestamp3?',
        name: 'EliWrapperComponent',
        params: true,
        component: () => import('../components/EliWrapperComponent.vue'),
        alias: ['/SlGlasnikPortal/eli/:level?/:issueType?/:authority?/:docType?/:gazetteYear(\\d+)?/:gazetteNumber(\\d+)?/:number(\\d+)?/:formatOrServiceOrTimestamp1?/:formatOrServiceOrTimestamp2?/:formatOrServiceOrTimestamp3?']
    },
    {
        path: '/eli/:level?/:issueType?/:authorityOrDocType?/:gazetteYear(\\d+)?/:gazetteNumber(\\d+)?/:number(\\d+)?/:formatOrServiceOrTimestamp1?/:formatOrServiceOrTimestamp2?/:formatOrServiceOrTimestamp3?',
        name: 'EliWrapperComponent',
        params: true,
        component: () => import('../components/EliWrapperComponent.vue'),
        alias: ['/SlGlasnikPortal/eli/:level?/:issueType?/:authorityOrDocType/:gazetteYear(\\d+)?/:gazetteNumber(\\d+)?/:number(\\d+)?/:formatOrServiceOrTimestamp1?/:formatOrServiceOrTimestamp2?/:formatOrServiceOrTimestamp3?']
    },
    {
        path: "*",
        component: () => import('../components/PageNotFound.vue'),
    },
    //----------------------------------Regulations--------------------------------------------------------
    {
        path: '/regulations-overview',
        name: 'RegulationsOverviewPage',
        component: () => import('../base_pages/regulations/RegulationsOverviewPage.vue')
    },
    {
        path: '/regulations-search',
        name: 'RegulationsSearchPage',
        component: () => import('../base_pages/regulations/RegulationsSearchPage.vue')
    },
    {

        path: '/regulations-static',
        name: 'BaseStaticPage',
        component: () => import('../base_pages/regulations/BaseStaticPage.vue')
    },
    {
        path: '/regulations/viewAct/:actId',
        name: 'REGULATIONS_ViewActPage',
        component: () => import('../base_pages/regulations/ViewActPage.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: window.BASE_URL,

    routes
});

// add the beforeEach hook
router.beforeEach((to, from, next) => {


    window.scrollTo(0, 0);
    //ukoliko greskom unesemo vise kosih crta, potrebno je da skloni visah, da bi se otvorila lepo stranica
    //(ovo je prvenstveno dodato zbog elija - iako se unese vise kosih crta treba da otvori odgovarajucu stranicu)
    const hasMultipleSlashes = to.fullPath.includes('//');
    if (hasMultipleSlashes) {
        const correctedPath = to.fullPath.replace(/\/{2,}/g, '/');
        next(correctedPath);
    }

    if (to.path.includes('/extref')) {
        let index = to.path.lastIndexOf('/extref');
        let newPath = to.path.substring(index + 8);
        //ovaj deo radimo da se ne bi nizalo vise /extref jedna na drugu (ukoliko smo vec na str /extref, 
        //pa ona ima link ka nekom drugom extref-u, gore u linku bi se oni nadovezivali)
        let parts = to.path.split('/');
        parts = parts.filter((part, idx) => {
            return part !== 'extref' || parts.indexOf(part) === idx;
        });
        let cleanedRoute = parts.join('/');
        if (to.path.includes('doctype=supa')) var link = getBaseSPApiUrl() + 'prins/viewdoc?uuid=' + newPath;
        else if (to.path.includes('doctype=ppp')) link = getBasePPPApiUrl() + 'ppp/viewdoc?uuid=' + newPath;
        else link = getBaseREGApiUrl() + 'viewdoc?uuid=' + newPath;
        Axios.get(link).then(res => {
            window.document.write(res.data);
            window.history.replaceState({ "html": res.data }, "", cleanedRoute)
        });
    }
    else if (to.path.includes('/prilozi')) {
        let index = to.path.indexOf('prilozi');
        let newPath = to.path.substr(index);
        // if (to.path.includes('slglrs') || to.path.includes('og')) 
        //     link = baseSLGLApiUrl + 'prins' + newPath;
        // if(to.path.includes('mml') || to.path.includes('lsd')) 
        //     link = baseMMLApiUrl + 'prins/' + newPath;
        // if(to.path.includes('ppp') || to.path.includes('wpp'))
        //     link = basePPPApiUrl + 'ppp/' + newPath + '?actId=' + to.query.actId + '&docType=wpp';
        //radi se o registru
        //else
        link = getBaseREGApiUrl() + newPath;
        document.body.style.display = "none";
        window.open(link, '_self');
    }
    else if (to.path.includes('/viewdoc')) {
        let index = to.path.indexOf('/viewdoc');
        // u slucaju da je path samo '/viewdoc bez ostatka'
        if (index === 0) var newPath = to.fullPath;
        //ako u ruti imamo /slGlasnikPortal deo
        //else if (index === 16) newPath = to.fullPath.substring(index);
        else newPath = to.fullPath.substring(index);
        //slgl
        if (to.query.doctype === 'og' || to.query.doctype == 'slgl') link = getBaseSLGLApiUrl() + 'prins' + newPath;
        //mml
        else if (to.query.doctype === 'mml' || to.query.doctype === 'lsd') link = getBaseMMLApiUrl() + 'prins' + newPath;
        //sp
        else if (to.query.doctype === 'sp' || to.query.doctype === 'supa') link = getBaseSPApiUrl() + 'prins' + newPath;
        //ppp
        else if (to.query.doctype === 'ppp' || to.query.doctype === 'wpp') link = getBasePPPApiUrl() + 'ppp' + newPath;
        //reg u ppp
        else if (to.query.doctype === 'reg' && to.path.includes('/ppp')) link = getBasePPPApiUrl() + 'ppp' + newPath;

        //trenutno ako je external gadja sudsku praksu, ali moze da gadja i slgl, mada na taj slucaj jos nismo naisli
        // potrebno izmeniti ako se dodje do te sitacije
        else if (to.query.external === 'true') link = getBaseSPApiUrl() + 'prins' + newPath;

        else link = getBaseREGApiUrl() + newPath.substr(1);
        Axios.get(link).then(res => {
            window.document.write(res.data);
        });
        document.body.style.display = "none";
    }
    else {
        next();
    }
});


export default router